import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import withAuthorization from '../higherOrder/withAuthorization'

import { } from '../../constants/routes'
import { getDevice, resetDeviceError } from '../../actions'
import { FillerDiv, CenteredDiv } from '../StyledComponents/Fillers'
import SensorDetails from '../Devices/SensorDetails'
import ValveDetails from '../Devices/ValveDetails'
import LoadingSpinner from '../Global/LoadingSpinner'
import NotFoundPage from './NotFound'

class DeviceDetailsPage extends Component {
    componentDidMount() {
        const { devices, match, type } = this.props

        if (!devices[match.params.uuid]) {
            this.props.getDevice(match.params.uuid, type)
        }
    }

    componentWillUnmount() {
        this.props.resetDeviceError()
    }

    render() {
        const { devices, match, type } = this.props

        const device = devices ? devices[match.params.uuid] : null

        if (!device) {
            if (devices.error) {
                return <NotFoundPage />
            }
            return <CenteredDiv><LoadingSpinner /></CenteredDiv>
        }

        switch (type) {
            case 'sensor':
                return <SensorDetails device={device} />
            case 'valve':
                return <ValveDetails device={device} />
            default:
        }

        return (
            <FillerDiv>
                Device not compatible yet...
            </FillerDiv>
        )
    }
}

const authCondition = authUser => !!authUser

const mapStateToProps = state => ({
    devices: state.devices,
})

export default compose(
    withAuthorization(authCondition),
    connect(mapStateToProps, { getDevice, resetDeviceError })
)(DeviceDetailsPage)



// WEBPACK FOOTER //
// ./src/components/pages/DeviceDetails.js